// frontend/src/captureAuth.ts
// Captura tokens de la URL (hash fragment) tras el callback de OAuth y los persiste
// en localStorage en la forma que espera @supabase/supabase-js.
// Ejecutar como módulo (type="module") desde index.html antes del bundle de la app.

(function () {
  try {
    // Usamos window.location.hash (por si la página ya redirigió)
    const h = window.location.hash || '';
    if (!h) return;

    if (h.indexOf('access_token=') === -1) {
      // No hay token en el hash
      return;
    }

    const params = new URLSearchParams(h.slice(1));
    const access_token = params.get('access_token');
    const refresh_token = params.get('refresh_token');
    const expires_at = params.get('expires_at') ? Number(params.get('expires_at')) : Math.floor(Date.now() / 1000) + 3600;

    if (!access_token) {
      // Nada que hacer
      return;
    }

    // Forma compatible con supabase-js: objeto con currentSession
    const tokenObj = {
      currentSession: {
        access_token: access_token,
        refresh_token: refresh_token,
        expires_at: expires_at,
        token_type: 'bearer'
      },
      user: null
    };

    try {
      localStorage.setItem('supabase.auth.token', JSON.stringify(tokenObj));
      localStorage.setItem('supabase.__captured_at', String(Date.now()));
      // Log para debugging en desarrollo
      // console.log('[captureAuth] token persisted, prefix:', access_token.slice(0,20) + '...');
    } catch (e) {
      console.warn('[captureAuth] could not persist auth token to localStorage', e);
    }

    // Limpiamos el fragmento de la URL para no exponer el token
    try {
      // dejamos el '#' vacío para mantener comportamiento SPA
      history.replaceState(null, '', window.location.pathname + window.location.search + '#');
    } catch (e) {
      // noop, no rompemos la carga por esto
    }
  } catch (err) {
    console.error('[captureAuth] error capturing auth hash', err);
  }
})();
